import React from "react";
import Card from "components/card";
import { displayIcon } from "variables/icons";

const SummaryHeader = ({
  title,
  icon: Icon,
  iconName,
  description,
  children,
  rightNav,
  color
}) => {

  return (
    <Card 
      className={`
        rounded-2xl overflow-hidden 
        p-4 sm:p-8 
        relative gradient ${color} text-white
      `}
    >

      <div className="flex items-start gap-3 w-full">

        {/* Icon */}
        <div className="
          p-2 sm:p-3
          rounded-xl sm:rounded-2xl
          bg-white/20 backdrop-blur-xl
          border border-white/30 shadow-2xl
          flex-shrink-0
        ">
          {iconName ? 
          displayIcon(iconName, 'w-5 h-5 sm:w-8 sm:h-8 text-white')
          : <Icon className="w-5 h-5 sm:w-8 sm:h-8 text-white"/>
          }
          
        </div>


        {/* Title + Description */}
        <div className="min-w-0 flex-1">

          <h1 className="
            text-xl sm:text-[28px]
            font-semibold text-white
            truncate
          ">
            {title}
          </h1>

          <p className="
            description text-sm
            break-words
          ">
            {description}
          </p>

        </div>


        {/* Right Nav */}
        {rightNav && (
          <div className="
            flex-shrink-0
            ml-auto
          ">
            {rightNav}
          </div>
        )}

      </div>


      {/* Children */}
      {children && (
        <div className="
          mt-6
          flex flex-col sm:flex-row
          gap-4 sm:gap-6
        ">
          {children}
        </div>
      )}

    </Card>
  );
};

export default SummaryHeader;